import React from "react";
import { composeDataMethods } from "@lululemon/mwa-utils";
const withDeviceCharacterization = Component => {
  const WithDeviceChar = props => {
    return /*#__PURE__*/React.createElement(Component, props);
  };
  composeDataMethods(Component, {
    getInitialProps: appContext => {
      var _ctx$req;
      const defaultDeviceType = {
        isDesktop: true,
        fallback: true
      };
      const ctx = (appContext === null || appContext === void 0 ? void 0 : appContext.ctx) || appContext;
      const deviceType = (ctx === null || ctx === void 0 ? void 0 : (_ctx$req = ctx.req) === null || _ctx$req === void 0 ? void 0 : _ctx$req.deviceType) || defaultDeviceType;
      return {
        deviceType
      };
    }
  })(WithDeviceChar);
  return WithDeviceChar;
};
export default withDeviceCharacterization;